
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface NavbarLogoProps {
  isLightBackground?: boolean;
}

const NavbarLogo: React.FC<NavbarLogoProps> = ({ isLightBackground = false }) => {
  const isMobile = useIsMobile();
  
  // Choose logo based on background brightness
  const logoSrc = isLightBackground 
    ? "/lovable-uploads/69d8478c-eb2f-4542-8353-09c3789bab30.png" // Dark logo for light backgrounds
    : "/lovable-uploads/d3067bc2-9035-4991-9bca-0568c3eedb0f.png"; // Light logo for dark backgrounds
  
  // Set logo size based on viewport
  const logoSize = isMobile ? 16 : 32; // 50% reduction for mobile
  
  return (
    <div className="flex items-center">
      <img 
        src={logoSrc}
        alt="Free Pomodoro Timer Logo" 
        id="app-logo"
        className={`w-auto ${isMobile ? 'h-16' : 'h-32'}`}
        width={logoSize * 4} 
        height={logoSize * 4}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </div>
  );
};

export default NavbarLogo;
